import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { sentimentOptions } from '../../constants/sentiment';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { TSentimentType } from '../../types';
import { sentimentPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
import { sentimentIconMap } from '@/pages/opinion/constants';
import { useIntl } from 'umi';
import BubbleCommon, { commonSentimentTips } from '../../../BubbleCommon';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { useOptionsMemo } from '../../hooks/common';

export default function SentimentSelect({
  changeOnCloseWindow,
  onChange,
  defaultKey,
  defaultValue,
  filterValue,
  oriDefaultFilter,
  lang,
  dealwithOptions,
  hasAllSelected,
}: TSentimentType) {
  const { formatMessage } = useIntl();
  const {
    selects: selectSentiment,
    setSelects: setSelectSentiment,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'sentiment',
    oriDefaultFilter,
    options: sentimentOptions(formatMessage).map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  function getCommonBackInfo() {
    const [text, isAll] = getButtonElement();
    return commonBackInfo(
      { sentiment: selectSentiment.map(Number) },
      { [defaultKey]: text },
      { needChangeEntity: true, isNumber: true, isAll },
    );
  }

  useEffect(() => {
    onChange?.('sentiment', getCommonBackInfo());
  }, [selectSentiment]);

  const sentimentValue = useMemo(() => {
    return selectSentiment.map(String);
  }, [selectSentiment]);

  const options = useOptionsMemo({
    options: sentimentOptions(formatMessage),
    dealwithOptions,
    key: 'sentiment',
    deeps: [formatMessage],
  });

  return (
    <div className={`sentiment-select-wrapper ${diffClassName}`}>
      <BubbleCommon
        placement="left"
        showIcon={false}
        tipsMap={commonSentimentTips}
      >
        <CustomSelect
          ref={customSelectRef}
          hasAllSelected={hasAllSelected}
          buttonItemRender={(value: any) => {
            return (
              <SvgIcon
                type={sentimentIconMap[value]}
                className="dbo-select-icon"
              />
            );
          }}
          buttonAllRender={options.map(({ value }) => (
            <SvgIcon
              key={value}
              type={sentimentIconMap[value]}
              className="dbo-select-icon"
            />
          ))}
          placeholderText={sentimentPlaceholder[lang]}
          onClear={() => setSelectSentiment([])}
          selectOptionsInfo={[sentimentValue, setSelectSentiment]}
          options={options}
          pointKey={FilterButtonPoint.sentiment}
          onChange={() => {
            const data = getCommonBackInfo();
            changeOnCloseWindow?.(data.value);
          }}
        ></CustomSelect>
      </BubbleCommon>
    </div>
  );
}
